module.exports = __webpack_public_path__ + "img/تایپوگرافی.ba97408c.png";